import React from 'react';
import { CheckCircle, Users, Crown, Clock, Shield } from 'lucide-react';

const WhyChooseUs = () => {
  const reasons = [
    {
      icon: CheckCircle,
      title: "End-to-End Execution",
      description: "From concept to performance, everything is handled seamlessly."
    },
    {
      icon: Users,
      title: "Designed for Large Audiences",
      description: "Proven experience managing 3000–5000+ attendees effortlessly."
    },
    {
      icon: Crown,
      title: "Premium, Classy Positioning",
      description: "No chaos, no over-noise—just refined, engaging entertainment."
    },
    {
      icon: Clock,
      title: "Time-Sensitive Precision",
      description: "We understand conference schedules and deliver accordingly."
    },
    {
      icon: Shield,
      title: "Zero Stress for Organizers",
      description: "We take complete ownership so you can focus on your event."
    }
  ];

  return (
    <section className="py-24 px-6 ivory-bg">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="heading-font text-4xl md:text-5xl font-bold text-black mb-4">
            Why Clients Choose Elysian Evenings
          </h2>
          <div className="w-24 h-1 gold-bg mx-auto mb-6"></div>
          <p className="body-font text-lg text-gray-700 max-w-3xl mx-auto">
            Designed for audiences that expect more
          </p>
        </div>

        {/* Reasons Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {reasons.map((reason, index) => {
            const IconComponent = reason.icon;
            return (
              <div 
                key={index}
                className="bg-white p-8 rounded-sm border-2 border-gray-200 hover:border-yellow-600 transition-all service-card"
              >
                <div className="gold-bg w-16 h-16 rounded-full flex items-center justify-center mb-6">
                  <IconComponent className="text-black" size={28} />
                </div>
                <h3 className="heading-font text-xl font-bold text-black mb-4">
                  {reason.title}
                </h3>
                <p className="body-font text-gray-700 leading-relaxed text-sm">
                  {reason.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Tagline */}
        <div className="text-center mt-16">
          <p className="heading-font text-2xl gold-accent italic font-light">
            "Luxury in experience. Excellence in execution."
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
